<template>
    <div>
        <QualitativeNoteDialog
            :is-open="qualitativeNoteDialog"
            :qualitative-note-data="currentQualitativeNote"
            :report-item-plate-data="reportItemPlate"
            :report-item-type-id="reportItemTypeId"
            :report-item-plate-id="reportItemPlateId"
            :reopen-report-items-dialog="reopenReportItemsDialog"
            @on-close="closeQualitativeNoteDialog"
        />
        <v-dialog
            :value="isOpen"
            max-width="1100px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Wyszukiwarka zleceń oraz zamówień
                    </h1>
                </v-card-title>

                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="5" lg="4">
                            <v-text-field
                                v-model="filters.reportItemPrimaryNumber"
                                label="Numer"
                                solo
                                hide-details
                                clearable
                            />
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                color="primary"
                                fab
                                small
                                elevation="1"
                                data-sentry-label="Szukaj"
                                :disabled="!filters.reportItemPrimaryNumber"
                                :loading="reportItemPlatesLoading"
                                @click="search"
                            >
                                <v-icon>
                                    mdi-magnify
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                :headers="headers"
                                :items="reportItemPlates"
                                :loading="reportItemPlatesLoading"
                                :mobile-breakpoint="0"
                                :footer-props="footerProps"
                                :server-items-length="pagination.itemsLength"
                                :page.sync="pagination.page"
                                :items-per-page.sync="pagination.itemsPerPage"
                                name="reportItemPlatesData"
                                @pagination="updatePagination"
                            >
                                <template #item.reportItemType="{item}">
                                    {{ item.reportItemType.name }}
                                </template>
                                <template #item.actions="{item}">
                                    <v-btn
                                        color="primary"
                                        text
                                        data-sentry-label="Wybierz"
                                        @click="showQualitativeNoteDialog(item)"
                                    >
                                        Wybierz
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Zamknij"
                        @click="onClose"
                    >
                        Zamknij
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import QualitativeNoteDialog from './QualitativeNoteDialog'
import filters from '@/mixins/dataTableFilters'
import dateFormatter from '@/mixins/dateFormatter'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
import { EventBus } from '@/utils/eventBus'

export default {
    name: 'ReportItemsDialog',
    components: {
        QualitativeNoteDialog
    },
    mixins: [
        dateFormatter, tooltipDelay, pagination, filters
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        reportItemTypeIdData: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            qualitativeNoteDialog: false,
            reportItemPlate: null,
            currentQualitativeNote: {},
            reportItemTypeId: null,
            reportItemPlateId: null,
            reopenReportItemsDialog: false,
            headers: [
                {
                    text: 'Numer',
                    sortable: false,
                    value: 'reportItemPrimaryNumber',

                },
                {
                    text: 'Typ',
                    sortable: false,
                    value: 'reportItemType',

                },
                {
                    text: 'Montaż',
                    sortable: false,
                    value: 'plateNumber',

                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ],
        }
    },
    computed: {
        reportItemPlates() {
            return this.$store.state.complaints.qualitativeNotes.reportItemPlates
        },
        reportItemPlatesLoading() {
            return this.$store.state.complaints.qualitativeNotes.reportItemPlatesLoading
        },
        savedFilters() {
            return this.$store.state.complaints.qualitativeNotes.reportItemPlateFilters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
    },
    methods: {
        getReportItemPlates() {
            this.actionLoading = true
            this.$store.dispatch('complaints/getReportItemPlates', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        search() {
            this.actionLoading = true
            this.getReportItemPlates()
        },
        showQualitativeNoteDialog(reportItemPlate) {
            this.reportItemPlateId = reportItemPlate.id
            this.reportItemPlate = reportItemPlate
            this.reportItemTypeId = reportItemPlate.reportItemTypeId
            this.qualitativeNoteDialog = true
            this.reopenReportItemsDialog = true
            EventBus.$emit('closeReportItemsDialog', false)
        },
        closeQualitativeNoteDialog(reopenReportItems) {
            this.qualitativeNoteDialog = false
            if (!reopenReportItems) this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.$store.dispatch('complaints/clearReportItemPlateFilters')
                this.filters = {}
                this.resetPagination()
            }, 500)
            this.$emit('on-close', true)
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && this.filters.reportItemPrimaryNumber) {
                this.getReportItemPlates()
            }
            this.clearPaginationPending()
        }
    }
}
</script>